import { useState, useEffect } from 'react'
import { getOnLineStatus } from '../utils/network'

export const useOnlineStatus = () => {
  const [isOnline, setIsOnline] = useState(getOnLineStatus())

  useEffect(() => {
    const handleOnline = () => setIsOnline(true)
    const handleOffline = () => setIsOnline(false)

    window.addEventListener('online', handleOnline)
    window.addEventListener('offline', handleOffline)

    return () => {
      window.removeEventListener('online', handleOnline)
      window.removeEventListener('offline', handleOffline)
    }
  }, [])

  return isOnline
}
